import { UPDATE_COMPANY_MUTATION } from "@/apis/gql/apolloClient";
import { useMutation } from "@apollo/client";

export const useUpdateCompany = () => {
  const [updateCompany] = useMutation(UPDATE_COMPANY_MUTATION);

  return { updateCompany };
};
